(function () {
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = [
      '.plp-card-swiper { width: 100%; height: 100%; --swiper-pagination-bottom: 0px; --swiper-pagination-bullet-horizontal-gap: 0px; }',
      '.plp-card-swiper .swiper-slide { overflow: hidden; }',
      '.plp-card-swiper .swiper-slide img { width: 100%; height: 100%; object-fit: cover; display: block; }',
      '.plp-card-swiper .swiper-pagination { position: absolute; bottom: 0; left: 0; right: 0; width: 100%; display: flex; gap: 10px; pointer-events: none; background: #A3A3A3;}',
      '.plp-card-swiper .swiper-pagination .swiper-pagination-bullet { flex: 1; height: 4px; border-radius: 0; background: #A3A3A3; opacity: 1; margin: 0; }',
      '.plp-card-swiper .swiper-pagination .swiper-pagination-bullet-active { background: #222222; }',
      '.card-wrapper[data-slider-init] .card__inner > .card__content { pointer-events: none; }',
      '.card-wrapper[data-slider-init] .card__inner > .card__content .lua-wishlist-button { pointer-events: auto; }',
    ].join(' ');
    document.head.appendChild(style);
  }

  // ── Color filtering ──────────────────────────────────────────────────────────

  function getActiveColor() {
    try {
      return (localStorage.getItem('farbfilter') || '').toLowerCase().trim();
    } catch (e) {
      return '';
    }
  }

  // Collect all known color keywords from swatch inputs on the page.
  function getAllColorKeywords() {
    var seen = {};
    var colors = [];
    document.querySelectorAll('input[type="radio"][data-color]').forEach(function (input) {
      var c = (input.dataset.color || '').toLowerCase().trim();
      if (c && !seen[c]) {
        seen[c] = true;
        colors.push(c);
      }
    });
    return colors;
  }

  // Parse "url:::alt||url:::alt" into [{url, alt}, ...]
  function parseSliderMedia(raw) {
    return (raw || '')
      .split('||')
      .filter(Boolean)
      .map(function (item) {
        var sep = item.indexOf(':::');
        return sep === -1 ? { url: item, alt: '' } : { url: item.slice(0, sep), alt: item.slice(sep + 3) };
      });
  }

  // Remove images whose alt contains 'tragebild' (case-insensitive).
  function filterOutTragebild(media) {
    return media.filter(function (item) {
      return (item.alt || '').toLowerCase().indexOf('tragebild') === -1;
    });
  }

  // Return up to 4 URLs filtered by activeColor:
  //   - images whose alt has NO known color keyword → always included (neutral)
  //   - images whose alt contains activeColor → included
  //   - images whose alt contains a DIFFERENT color keyword → excluded
  // Falls back to first 4 if nothing matches.
  function filterByColor(allMedia, activeColor) {
    var allColors = getAllColorKeywords();
    var activeLower = (activeColor || '').toLowerCase().trim();

    var filtered = allMedia.filter(function (item) {
      var alt = (item.alt || '').toLowerCase();
      var matchedColors = allColors.filter(function (c) {
        return alt.indexOf(c) !== -1;
      });
      if (matchedColors.length === 0) return true; // neutral
      return activeLower && matchedColors.indexOf(activeLower) !== -1;
    });

    var result = filtered.length > 0 ? filtered : allMedia;
    return result.slice(0, 4).map(function (item) {
      return item.url;
    });
  }

  // ── Swiper ───────────────────────────────────────────────────────────────────

  function buildSwiperHTML(images) {
    var slides = images
      .map(function (url, i) {
        return (
          '<div class="swiper-slide"><img src="' +
          url +
          '" alt="" loading="' +
          (i === 0 ? 'eager' : 'lazy') +
          '" draggable="false" class="motion-reduce"></div>'
        );
      })
      .join('');
    return (
      '<div class="swiper plp-card-swiper"><div class="swiper-wrapper">' +
      slides +
      '</div><div class="swiper-pagination"></div></div>'
    );
  }

  function mountSwiper(mediaDiv, images, cardWrapper) {
    mediaDiv.classList.remove('is-loading');
    mediaDiv.innerHTML = buildSwiperHTML(images);
    var swiperEl = mediaDiv.querySelector('.plp-card-swiper');
    swiperEl.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: false,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: false,
      },
      on: {
        click: function (swiper, event) {
          if (!event) return;
          var url = cardWrapper.dataset.currentUrl;
          if (url) window.location.href = url;
        },
      },
    });
  }

  function rebuildSlider(mediaDiv, cardWrapper, colorOverride) {
    var allMedia = parseSliderMedia(cardWrapper.dataset.sliderAll);
    if (!allMedia.length) return;
    var color = colorOverride !== undefined ? colorOverride : getActiveColor();
    var images = filterByColor(allMedia, color);
    if (images.length < 2) return;
    var existing = mediaDiv.querySelector('.plp-card-swiper');
    if (existing && existing.swiper) existing.swiper.destroy(true, true);
    mountSwiper(mediaDiv, images, cardWrapper);
  }

  // Rebuild slider from the sibling's data-all-images (set on the swatch input).
  // Used for both manual swatch clicks and applyColorFromFilter calls.
  function rebuildFromInput(input, mediaDiv, cardWrapper) {
    var raw = input && input.dataset.allImages;
    var color = (input && input.dataset.color) ? input.dataset.color : getActiveColor();
    var tragebildBlocked = cardWrapper.hasAttribute('data-tragebild-blocked');

    if (raw) {
      var siblingMedia = parseSliderMedia(raw);
      if (tragebildBlocked) siblingMedia = filterOutTragebild(siblingMedia);
      var images = filterByColor(siblingMedia, color);
      if (images.length >= 1) {
        var existing = mediaDiv.querySelector('.plp-card-swiper');
        if (existing && existing.swiper) existing.swiper.destroy(true, true);
        mountSwiper(mediaDiv, images, cardWrapper);
      }
    } else {
      // Fallback if sibling data not available: filter current card's images by color.
      rebuildSlider(mediaDiv, cardWrapper, color.toLowerCase().trim());
    }

    if (input && input.dataset.url) {
      var code = new URLSearchParams(window.location.search).get('code');
      cardWrapper.dataset.currentUrl = code
        ? input.dataset.url + (input.dataset.url.includes('?') ? '&' : '?') + 'code=' + code
        : input.dataset.url;
    }
  }

  // ── Card init ────────────────────────────────────────────────────────────────

  function initCardSlider(cardWrapper) {
    var raw = cardWrapper.dataset.sliderAll;
    if (!raw) return;

    var mediaDiv = cardWrapper.querySelector('.card__media .media');
    if (!mediaDiv) return;

    // If applyColorFromFilter already ran before initPLPSlider (which is the normal case),
    // a swatch input is already :checked. Use its sibling images + color so the slider
    // reflects the currently active color, not the initial card product's color.
    var checkedSwatch = cardWrapper.querySelector('input[type="radio"][name^="color-"]:checked');

    var tragebildBlocked = cardWrapper.hasAttribute('data-tragebild-blocked');
    var images;
    if (checkedSwatch && checkedSwatch.dataset.allImages) {
      var siblingMedia = parseSliderMedia(checkedSwatch.dataset.allImages);
      if (tragebildBlocked) siblingMedia = filterOutTragebild(siblingMedia);
      images = filterByColor(siblingMedia, checkedSwatch.dataset.color || getActiveColor());
    }
    // Fallback: if no checked swatch with data, or filtered result is too small,
    // use the card's own image set filtered by the active color.
    if (!images || images.length < 2) {
      var allMedia = parseSliderMedia(raw);
      images = filterByColor(allMedia, getActiveColor());
    }

    if (images.length < 2) return;

    var cardLink = cardWrapper.closest('a.full-unstyled-link');
    // cardLink.href is already updated to the active sibling's URL by updateImageURL.
    cardWrapper.dataset.currentUrl = cardLink ? cardLink.href : '';

    if (cardLink) {
      cardLink.removeAttribute('onclick');
      cardLink.href = 'javascript:void(0)';
    }

    // Override updateImageURL so applyColorFromFilter (called directly, no change event)
    // rebuilds the slider for the new color instead of just swapping one img src.
    var variantSelector = cardWrapper.querySelector('lua-variant-selector');
    if (variantSelector && typeof variantSelector.updateImageURL === 'function') {
      variantSelector.updateImageURL = function (input) {
        if (cardLink) cardLink.href = 'javascript:void(0)';
        rebuildFromInput(input, mediaDiv, cardWrapper);
      };
    }

    // Card text / info area click → navigate.
    cardWrapper.addEventListener('click', function (e) {
      if (e.target.closest('.card__media')) return;
      if (e.target.closest('input, button, label')) return;
      var url = cardWrapper.dataset.currentUrl;
      if (url) window.location.href = url;
    });

    mountSwiper(mediaDiv, images, cardWrapper);
    cardWrapper.dataset.sliderInit = 'true';

    // User clicks a color swatch → rebuild slider from sibling's full image set.
    cardWrapper.querySelectorAll('input[type="radio"][name^="color-"]').forEach(function (input) {
      input.addEventListener('change', function (e) {
        e.stopPropagation();
        rebuildFromInput(input, mediaDiv, cardWrapper);
      });
    });
  }

  function initAllCardSliders() {
    if (!isMobile()) return;
    document.querySelectorAll('.card-wrapper[data-slider-all]:not([data-slider-init])').forEach(initCardSlider);
  }

  window.initPLPSlider = function () {
    if (!isMobile()) return;
    if (typeof Swiper === 'undefined') {
      console.warn('[AB] Swiper not loaded');
      return;
    }
    injectStyles();
    initAllCardSliders();
    document.addEventListener('facets:updated', initAllCardSliders);
  };
})();
